import React, { useEffect, useState } from "react";
import {
  ClipboardDocumentCheckIcon,
  ClipboardDocumentListIcon,
  BuildingStorefrontIcon,
} from "@heroicons/react/24/outline";
import ContentLoader from "react-content-loader";
import { getAllEnquiry } from "../apis/enquiryApi";
import { getAllLead } from "../apis/leadApi";
import { getAllFranchise } from "../apis/franchise";
import { getAllEmployeeWork } from "../apis/workApis";
import { useAuth } from "../context/AuthProvider";

const Dashboard = () => {
  const { user } = useAuth();

  const [loading, setLoading] = useState(true);

  const [enquiryCount, setEnquiryCount] = useState(0);
  const [leadCount, setLeadCount] = useState(0);
  const [franchiseCount, setFranchiseCount] = useState(0);
  const [assignedWork, setAssignedWork] = useState(0);

  useEffect(() => {
    if (!user) return;

    const fetchDashboardData = async () => {
      setLoading(true);
      try {
        if (user.role === "super-admin") {
          const [enqRes, leadRes, franRes] = await Promise.all([
            getAllEnquiry(),
            getAllLead(),
            getAllFranchise(),
          ]);

          setEnquiryCount(enqRes?.data?.length || 0);
          setLeadCount(leadRes?.data?.length || 0);
          setFranchiseCount(franRes?.data?.length || 0);
        } else {
          const res = await getAllEmployeeWork();
          setAssignedWork(res?.data?.length || 0);
        }
      } catch (err) {
        console.error("Dashboard error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [user]);

  const SkeletonCard = () => (
    <ContentLoader
      speed={2}
      width="100%"
      height={100}
      backgroundColor="#e5e7eb"
      foregroundColor="#f3f4f6"
      className="rounded-lg"
    >
      <rect x="20" y="20" rx="6" ry="6" width="60" height="60" />
      <rect x="100" y="30" rx="4" ry="4" width="180" height="14" />
      <rect x="100" y="55" rx="4" ry="4" width="120" height="12" />
    </ContentLoader>
  );

  return (
    <div className="p-6 min-h-screen">
      <h2 className="text-2xl font-semibold mb-6">Dashboard</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {loading ? (
          <>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </>
        ) : user.role === "super-admin" ? (
          <>
            {/* ENQUIRIES */}
            <div className="bg-gradient-to-r from-blue-500 to-blue-700 p-6 rounded-xl shadow-lg flex items-center gap-4">
              <ClipboardDocumentListIcon className="h-12 w-12 text-white" />
              <div>
                <h3 className="text-3xl font-bold text-white">
                  {enquiryCount}
                </h3>
                <p className="text-white">Enquiries</p>
              </div>
            </div>

            {/* LEADS */}
            <div className="bg-gradient-to-r from-green-500 to-green-700 p-6 rounded-xl shadow-lg flex items-center gap-4">
              <ClipboardDocumentCheckIcon className="h-12 w-12 text-white" />
              <div>
                <h3 className="text-3xl font-bold text-white">
                  {leadCount}
                </h3>
                <p className="text-white">Leads</p>
              </div>
            </div>

            {/* FRANCHISES */}
            <div className="bg-gradient-to-r from-orange-500 to-orange-700 p-6 rounded-xl shadow-lg flex items-center gap-4">
              <BuildingStorefrontIcon className="h-12 w-12 text-white" />
              <div>
                <h3 className="text-3xl font-bold text-white">
                  {franchiseCount}
                </h3>
                <p className="text-white">Franchises</p>
              </div>
            </div>
          </>
        ) : (
          <div className="bg-gradient-to-r from-blue-500 to-blue-700 p-6 rounded-xl shadow-lg flex items-center gap-4">
            <ClipboardDocumentListIcon className="h-12 w-12 text-white" />
            <div>
              <h3 className="text-3xl font-bold text-white">
                {assignedWork}
              </h3>
              <p className="text-white">Assigned Works</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
